import { Textfit } from '@wwe-portal/ui/components/text-fit';

const sqSize = 80;
const strokeWidth = 5;
export function Body({
  percentage,
  wweLogo,
  successLogo,
}: {
  percentage: number;
  wweLogo?: string;
  successLogo?: string;
}) {
  return (
    <div className="bg-body-modal pointer-events-none absolute inset-[3.5px] top-[50px] flex flex-col items-center justify-center bg-contain bg-center bg-no-repeat">
      {successLogo ? (
        <img
          alt="success"
          className="object-cover"
          height={sqSize}
          src={successLogo}
          width={sqSize}
        />
      ) : null}
      {wweLogo ? (
        <CircularProgressBar percentage={percentage} wweLogo={wweLogo} />
      ) : null}

      <Textfit
        className="font-champion w-[200px] text-center text-lg text-[#E3E7F4]"
        max={18}
        mode="multi"
      >
        Your rewards have been sent to your in-game Inbox
      </Textfit>
    </div>
  );
}

function CircularProgressBar({
  percentage,
  wweLogo,
}: {
  percentage: number;
  wweLogo: string;
}) {
  const radius = (sqSize - strokeWidth) / 2;
  const viewBox = `0 0 ${sqSize} ${sqSize}`;
  const dashArray = radius * Math.PI * 2;
  const dashOffset = dashArray - (dashArray * percentage) / 100;

  return (
    <svg fill="none" height={sqSize} viewBox={viewBox} width={sqSize}>
      <circle
        cx={sqSize / 2}
        cy={sqSize / 2}
        r={radius}
        stroke="#4f5794"
        strokeWidth={`${strokeWidth}px`}
      />
      <circle
        cx={sqSize / 2}
        cy={sqSize / 2}
        r={radius}
        stroke="#f9a019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={`${strokeWidth}px`}
        style={{
          strokeDasharray: dashArray,
          strokeDashoffset: dashOffset,
        }}
        transform={`rotate(-90 ${sqSize / 2} ${sqSize / 2})`}
      />
      <image height="50" width="50" x="15" xlinkHref={wweLogo} y="15" />
    </svg>
  );
}
